// This example uses the autocomplete feature of the Google Places API.
// It allows the user to find all hotels in a given place, within a given
// country. It then displays markers for all the hotels returned,
// with on-click details for each hotel.
// This example requires the Places library. Include the libraries=places
// parameter when you first load the API. For example:
// <script src="https://maps.googleapis.com/maps/api/js?key=YOUR_API_KEY&libraries=places">
let map;
let places;
let infoWindow;
let markers = [];
let autocomplete;
const countryRestrict = { country: "us" };
const MARKER_PATH ="https://developers.google.com/maps/documentation/javascript/images/marker_green";
const hostnameRegexp = new RegExp("^https?://.+?/");

const defaultLocation={ lat: 15, lng: 0 };
let stores=[];
var geocoder;
let userPositionInfo;

let pBtnLoading=false;
let activeInfoWindow;
let defaultZoom;
let autoZoom;

/*
const countries = {
  au: {
    center: { lat: -25.3, lng: 133.8 },
    zoom: 4,
  },
  br: {
    center: { lat: -14.2, lng: -51.9 },
    zoom: 3,
  },
  ca: {
    center: { lat: 62, lng: -110.0 },
    zoom: 3,
  },
  fr: {
    center: { lat: 46.2, lng: 2.2 },
    zoom: 5,
  },
  de: {
    center: { lat: 51.2, lng: 10.4 },
    zoom: 5,
  },
  mx: {
    center: { lat: 23.6, lng: -102.5 },
    zoom: 4,
  },
  nz: {
    center: { lat: -40.9, lng: 174.9 },
    zoom: 5,
  },
  it: {
    center: { lat: 41.9, lng: 12.6 },
    zoom: 5,
  },
  za: {
    center: { lat: -30.6, lng: 22.9 },
    zoom: 5,
  },
  es: {
    center: { lat: 40.5, lng: -3.7 },
    zoom: 5,
  },
  pt: {
    center: { lat: 39.4, lng: -8.2 },
    zoom: 6,
  },
  us: {
    center: { lat: 37.1, lng: -95.7 },
    zoom: 3,
  },
  uk: {
    center: { lat: 54.8, lng: -4.6 },
    zoom: 5,
  },
};
*/

// 2. 发起AJAX请求获取数据
async function fetchQueryStores(query, variables) {
  const response = await fetch(`/apps/tsarbomba-app/queryStores`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json'
      // 'X-Proxy-Access-Token': 'YOUR_PROXY_SECRET_TOKEN_HERE' // 与后端环境变量一致
    },
    body: JSON.stringify({ query, variables }),
  });
  
    try {
   
      const result = await response.json();
      
      // 3. 检查并处理返回的数据
      if (result.errors) {
        console.error('GraphQL查询错误:', result.errors);
        return;
      }
      console.log(result);
      const storesData = result.data;

      if(storesData.length>0){
        storesData.forEach(store => {
          let obj={}

          store.fields.forEach(item => {
            if(item.key=="name"){
              obj.name=item.value
            }
            if(item.key=="email"){
                obj.email=item.value
            }
            if(item.key=="phone"){
                obj.phone=item.value
            }
            if(item.key=="web_text"){
                obj.web_text=item.value
            }
            if(item.key=="web_link"){
                obj.web_link=item.value
            }
            if(item.key=="country"){
                obj.country=item.value
            }
            if(item.key=="state"){
                obj.state=item.value
            }
            if(item.key=="city"){
                obj.city=item.value
            }
            if(item.key=="postal_code"){
              obj.postal_code=item.value
            }
            if(item.key=="textarea"){
                obj.street=item.value
            }
            if(item.key=="latitude"){
              obj.latitude=item.value
            }
            if(item.key=="longitude"){
              obj.longitude=item.value
            }
            if(item.key=="handle"){
              obj.handle=item.value
            }


          })

          if(store.store_image!=null){
            if(store.store_image.reference!=null){
                 obj.store_image=store.store_image.reference.image.url
            }else{
              obj.store_image=""
            }
           
          }else{
            obj.store_image=""
          }

          if(store.handle!=null){
            obj.handle=store.handle
          }else{
            obj.handle=""
          }

          stores.push(obj);
        
        })

       
      }
    
      // 4. 调用渲染函数
    // renderStores(stores);
      
    } catch (error) {
      console.error('获取数据失败:', error);
    }

  if(stores.length>0){
     markLocationOnMap(stores);
   }
}


//let google_map_stores_new=[]
let currentCursor = null; // 当前游标，初始为null表示从第一页开始
let hasMore = true; // 是否还有更多数据

async function fetchAllStores() {

  // 循环执行，直到 hasMore 为 false
  while (hasMore) {

    const variables = { cursor: currentCursor };
    const url = `https://${SHOP_DOMAIN}/api/2024-01/graphql.json`; // API端点，年份随版本更新
    const options = {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        'X-Shopify-Storefront-Access-Token': ACCESS_TOKEN
      },
      body: JSON.stringify({ query: GRAPHQL_QUERY, variables  })
    };

    try {
      const response = await fetch(url, options);
      const result = await response.json();
      
      // 3. 检查并处理返回的数据
      if (result.errors) {
        console.error('GraphQL查询错误:', result.errors);
        return;
      }
      
      const storesData = result.data.metaobjects.nodes;

      // 更新分页状态
      hasMore = result.data.metaobjects.pageInfo.hasNextPage;
      currentCursor = result.data.metaobjects.pageInfo.endCursor; // 更新游标，用于下次请求
      console.log(result.data.metaobjects.pageInfo)
      console.log(`成功获取 ${storesData.length} 条门店数据`, storesData);
      
      if(storesData.length>0){
        storesData.forEach(store => {
          let obj={}

          store.fields.forEach(item => {
            if(item.key=="name"){
              obj.name=item.value
            }
            if(item.key=="email"){
                obj.email=item.value
            }
            if(item.key=="phone"){
                obj.phone=item.value
            }
            if(item.key=="web_text"){
                obj.web_text=item.value
            }
            if(item.key=="web_link"){
                obj.web_link=item.value
            }
            if(item.key=="country"){
                obj.country=item.value
            }
            if(item.key=="state"){
                obj.state=item.value
            }
            if(item.key=="city"){
                obj.city=item.value
            }
            if(item.key=="postal_code"){
              obj.postal_code=item.value
            }
            if(item.key=="street"){
                obj.street=item.value
            }
            if(item.key=="latitude"){
              obj.latitude=item.value
            }
            if(item.key=="longitude"){
              obj.longitude=item.value
            }
            if(item.key=="handle"){
              obj.handle=item.value
            }


          })

          if(store.store_image!=null){
            if(store.store_image.reference!=null){
                 obj.store_image=store.store_image.reference.image.url
            }else{
              obj.store_image=""
            }
           
          }else{
            obj.store_image=""
          }

          if(store.handle!=null){
            obj.handle=store.handle
          }else{
            obj.handle=""
          }

          stores.push(obj);
        
        })

       
      }
    
      // 4. 调用渲染函数
    // renderStores(stores);
      
    } catch (error) {
      console.error('获取数据失败:', error);
    }

  }

   //console.log(stores)
   if(stores.length>0){
     markLocationOnMap(stores);
   }
  

}




  function  getStoresData() {
    const dataEl = document.querySelector('#google_map_stores');//[id^="product-json-"][type="application/json"]document.getElementById('compare-resources');
    return JSON.parse(dataEl.textContent);
  }



   
function initMap() {
  map = new google.maps.Map(document.getElementById("map"), {
  //  zoom: 2,
  //  center: defaultLocation,
    mapTypeControl: false,
    panControl: false,
    zoomControl: false,
    streetViewControl: false,
  });
  defaultZoom=map.getZoom();
  autoZoom=map.getZoom();
//fetchAllStores()

let currentCursor = null;
const variables = { cursor: currentCursor };
fetchQueryStores(GRAPHQL_QUERY,variables);
//getStoresData();
  // 店铺数据
  // stores = getStoresData();
  
  // markLocationOnMap(stores);


  infoWindow = new google.maps.InfoWindow({
    content: document.getElementById("info-content"),
  });
  // Create the autocomplete object and associate it with the UI input control.
  // Restrict the search to the default country, and to place type "cities".
  autocomplete = new google.maps.places.Autocomplete(
    document.getElementById("autocomplete"),
    {
      //types: ["(cities)"],
      //componentRestrictions: countryRestrict,
      fields: ["geometry","address_components"],
    },
  );
  places = new google.maps.places.PlacesService(map);
  autocomplete.addListener("place_changed", onPlaceChangedV2);
  geocoder = new google.maps.Geocoder();
  // Add a DOM event listener to react when the user selects a country.
 // document.getElementById("country").addEventListener("change", setAutocompleteCountry);
}


// 在地图上标记位置
function markLocationOnMap(stores) {

  const rerultCount = document.querySelector('.map-left-bottom .find-count');
  rerultCount.textContent=stores.length;

    clearStores();
    clearMarkers();

    if(stores.length>0){
      // 假设 markers 是您当前地图上所有标记的数组
      var bounds = new google.maps.LatLngBounds();

      for (let i = 0; i < stores.length; i++) {
        const store = stores[i];
        //const location={lat: store.latitude, lng: store.longitude }
        let position = new google.maps.LatLng(store.latitude, store.longitude);
      // 创建新标记
        markers[i] = new google.maps.Marker({
            position: position,
            map: map,
            title: store.name
        });

        // 设置弹跳
         markers[i].setAnimation(google.maps.Animation.BOUNCE);
        
        // 设置弹跳时间
        setTimeout(() => {
          markers[i].setAnimation(null); // 停止弹跳
        }, 2000); // 5秒后停止
        
        bounds.extend(position); // 关键步骤：将此点纳入边界计算

        let storeEl = createStoreEl(store,i);
        //左侧店铺信息
        addStore(storeEl);
        
        //setTimeout(dropMarker(i), i * 100);

        
        const copyStoreEl =storeEl.cloneNode(true);
        // 创建信息窗口
            const infoWindow2 = new google.maps.InfoWindow({
                content:copyStoreEl 
            });

        // 创建信息窗口
        //google.maps.event.addListener(markers[i], "click", showInfoWindowV2);
        google.maps.event.addListener(markers[i], "click", ()=>{
          // 方法2：增加缩放级别（放大）
          if(autoZoom == map.getZoom()){
            // 方法2：增加缩放级别（放大）
            map.setZoom(map.getZoom() + 2);
          }
          //map.setZoom(5);
          // 可选：将地图中心移动到标记位置
          map.setCenter(markers[i].getPosition());

          // 设置弹跳
         markers[i].setAnimation(google.maps.Animation.BOUNCE);
        
        // 设置弹跳时间
        setTimeout(() => {
          markers[i].setAnimation(null); // 停止弹跳
        }, 2000); // 5秒后停止

          if(activeInfoWindow){
            activeInfoWindow.close();
            activeInfoWindow = null;
          }
          infoWindow2.open(map, markers[i]);
          activeInfoWindow = infoWindow2;
        });
        setTimeout(dropMarker(i), i * 100);


    }

      google.maps.event.trigger(map, 'resize');
      // 最后，让地图适配计算出的边界，所有标记将完美呈现
      map.fitBounds(bounds);
      autoZoom=map.getZoom();
      
      
  }



  
}
function searchV2(){
    //map.panTo(defaultLocation); 
    let inputTxt = document.getElementById("autocomplete").value;

    if(inputTxt !=null && inputTxt != "" ){
        inputTxt = inputTxt.replace(/\s+/g, '');
        inputTxt = inputTxt.toLowerCase();

        let filterStores =[];
        stores.forEach(store => {
          let storeCountry = store.country;
          if(storeCountry != "" && storeCountry != null){
              storeCountry = storeCountry.replace(/\s+/g, '');
              storeCountry = storeCountry.toLowerCase();
          }
          let storeState = store.state;
          if(storeState != "" && storeState != null){
            storeState = storeState.replace(/\s+/g, '');
            storeState = storeState.toLowerCase();
          }
          let storeCity = store.city;
          if(storeCity != "" && storeCity != null){
            storeCity = storeCity.replace(/\s+/g, '');
            storeCity = storeCity.toLowerCase();
          }

          let storeName = store.name;
          if(storeName != "" && storeName != null){
            storeName = storeName.replace(/\s+/g, '');
            storeName = storeName.toLowerCase();
          }

          let storeStreet = store.street;
          if(storeStreet != "" && storeStreet != null){
            storeStreet = storeStreet.replace(/\s+/g, '');
            storeStreet = storeStreet.toLowerCase();
          }

          if(storeCountry!=undefined&&storeCountry!=null&&storeCountry.includes(inputTxt) || storeState!=undefined&&storeState!=null&&storeState.includes(inputTxt)  || storeCity!=undefined&&storeCity!=null&&storeCity.includes(inputTxt) || storeName!=undefined&&storeName!=null&&storeName.includes(inputTxt) || storeStreet!=undefined&&storeStreet!=null&&storeStreet.includes(inputTxt)){
            filterStores.push(store);
          }
          
        });
        //console.log(filterStores)
        markLocationOnMap(filterStores);

    }else{
        if(markers.length < stores.length){
          markLocationOnMap(stores);
        }
    }
    //console.log(markers.length)
     //console.log(stores.length)
}

function reSet(){
 // if(markers.length < stores.length){
      markLocationOnMap(stores);
 // }else{
    // map.setZoom(defaultZoom);
 // }
}

function positioning(){
  // 尝试获取用户当前位置
  if (navigator.geolocation) {
      navigator.geolocation.getCurrentPosition(
           function(position) {
             /* alert('位置获取成功！\n纬度: ' + position.coords.latitude + 
                    '\n经度: ' + position.coords.longitude);*/
            if(userPositionInfo==null || userPositionInfo == "" || userPositionInfo == undefined){
              const latlng = {lat:position.coords.latitude,lng:position.coords.longitude};
             // console.log(userPositionInfo)
              getGeocode(latlng);
              //console.log(userPositionInfo)
              
            }else{
              const stores = filterStores(userPositionInfo);
               markLocationOnMap(stores);
                setTimeout(() => {

                  const searchInput = document.querySelector('.search-input input');
                  searchInput.value=userPositionInfo.formatted_address
                  pBtnLoading=false;
                  const positionBtn = document.querySelector('.map-left-top .position-btn');
                  positionBtn.classList.remove('custom-icon');
                  
                }, 200);
            }
            

          
          },
          function(error) {
              let errorMessage = '';
              switch(error.code) {
                  case error.PERMISSION_DENIED:
                      errorMessage = 'Location permission denied. Please find the "Location" of the website information and set it to "Allow".\n \n Chrome browser PC: Click on the icon on the left side of the address bar, find the "Location" permission setting in the pop-up menu, and change the setting from "Reject" to "Allow" \n \n Chrome browser mobile: Click on the three point menu in the upper right corner, select "Website Settings" or "Site Settings", find the "Location" permission option, and change the setting to "Allow" or "Ask" \n \n Other Browser  ...';
                      break;
                  case error.POSITION_UNAVAILABLE:
                      errorMessage = 'Location information is not available.';
                      break;
                  case error.TIMEOUT:
                      errorMessage = 'Location request timed out.';
                      break;
                  default:
                      errorMessage = 'An unknown error has occurred.';
              }
              alert('Error: ' + errorMessage);
              pBtnLoading=false;
              const positionBtn = document.querySelector('.map-left-top .position-btn');
              positionBtn.classList.remove('custom-icon');
          }
      )
  } else {
    alert('Your browser does not support geolocation functionality.');
  }
}

function filterStores(locationInfo){
    let locationCountry = locationInfo.country.replace(/\s+/g, '');
    locationCountry = locationCountry.toLowerCase();
    //console.log(locationInfo)
    //console.log(locationCountry)

   // const filterStores = stores.filter(item => item.country == locationInfo.country ||  item.state == locationInfo.country || item.city== locationInfo.country);
   let filterStores =[];
    stores.forEach(store => {
      let storeCountry = store.country;
      if(storeCountry != "" && storeCountry != null){
          storeCountry = storeCountry.replace(/\s+/g, '');
          storeCountry = storeCountry.toLowerCase();
      }
      let storeState = store.state;
      if(storeState != "" && storeState != null){
        storeState = storeState.replace(/\s+/g, '');
        storeState = storeState.toLowerCase();
      }
      let storeCity = store.city;
      if(storeCity != "" && storeCity != null){
        storeCity = storeCity.replace(/\s+/g, '');
        storeCity = storeCity.toLowerCase();
      }

      if(storeCountry == locationCountry || storeState == locationCountry  || storeCity == locationCountry){
        filterStores.push(store);
      }
      
    });

    return filterStores;
}


function getGeocode(latlng){
  // 假设你已初始化Geocoder对象

//var latlng = {lat: 40.714224, lng: -73.961452}; // 示例坐标

geocoder.geocode({'location': latlng}, function(results, status) {
  if (status === 'OK') {

    console.log(results)
    if (results.length>0) {
      // 遍历返回的第一个完整地址的所有地址组件
      var addressComponents = results[0].address_components;
      var addressInfo = {};
      if(results[0].formatted_address != null){
        addressInfo.formatted_address=results[0].formatted_address;
      }
      
      for (var i = 0; i < addressComponents.length; i++) {
        var component = addressComponents[i];
        // 根据类型填充信息
        if (component.types.indexOf('country') !== -1) {
          addressInfo.country = component.long_name; // 国家完整名称
          addressInfo.country_code = component.short_name; // 国家代码
        }
        if (component.types.indexOf('administrative_area_level_1') !== -1) {
          addressInfo.state = component.long_name; // 省或州
        }
        if (component.types.indexOf('administrative_area_level_2') !== -1) {
          addressInfo.city = component.long_name; // 城市
        }
        if (component.types.indexOf('locality') !== -1) {
          // 如果administrative_area_level_2不存在，locality作为城市
          //addressInfo.city = addressInfo.city || component.long_name;
          addressInfo.city = addressInfo.city || component.long_name;
        }
      }
      
      userPositionInfo = addressInfo;
      
      // 打印解析出的地址信息
      //console.log("国家:", addressInfo.country);
     // console.log("省份:", addressInfo.province);
      //console.log("城市:", addressInfo.city);

        const stores = filterStores(userPositionInfo);
        //console.log(filterStores)
        markLocationOnMap(stores);
      
    } else {
      //console.log('未找到结果');
    
    }
  } else {
   // console.log('Geocoder失败，原因: ' + status);
  
  }


    const searchInput = document.querySelector('.search-input input');
    searchInput.value=userPositionInfo.formatted_address
    pBtnLoading=false;
    const positionBtn = document.querySelector('.map-left-top .position-btn');
    positionBtn.classList.remove('custom-icon');



});
}

function showInfoWindowV2() {
    const marker = this;

    infoWindow.open(map, marker);
}

// 从地点数据中提取城市信息
function extractCityInfo(place) {
    let city = '';
    let state = '';
    let country = '';
    let postalCode = '';
    
    // 遍历地址组件
    for (const component of place.address_components) {
        const componentType = component.types;
        
        if (componentType.includes('locality')) {
            city = component.long_name;
        }
        
        if (componentType.includes('administrative_area_level_1')) {
            state = component.long_name;
        }
        
        if (componentType.includes('country')) {
            country = component.long_name;
        }
        
        if (componentType.includes('postal_code')) {
            postalCode = component.long_name;
        }
    }
    
    return {
        city,
        state,
        country,
        postalCode,
        formattedAddress: place.formatted_address,
        location: place.geometry.location
    };
}


function onPlaceChangedV2() {
  const place = autocomplete.getPlace();
   //console.log(place)
  if (place.geometry && place.geometry.location) {
    //map.panTo(place.geometry.location);
    //map.setZoom(15);

    const locationInfo = extractCityInfo(place)
    const stores = filterStores(locationInfo);
    //console.log(stores)
    markLocationOnMap(stores);
    //search();
  } else {
    document.getElementById("autocomplete").placeholder = "Enter country, region, city or address";
  }
}
// When the user selects a city, get the place details for the city and
// zoom the map in on the city.
function onPlaceChanged() {
  const place = autocomplete.getPlace();
   console.log(place)
  if (place.geometry && place.geometry.location) {
    map.panTo(place.geometry.location);
    map.setZoom(15);
    search();
  } else {
    document.getElementById("autocomplete").placeholder = "Enter country, region, city or address";
  }
}

// Search for hotels in the selected city, within the viewport of the map.
function search() {
  const search = {
    bounds: map.getBounds(),
    types: ["lodging"],
  };

  places.nearbySearch(search, (results, status, pagination) => {
    if (status === google.maps.places.PlacesServiceStatus.OK && results) {
      clearResults();
      clearMarkers();

      // Create a marker for each hotel found, and
      // assign a letter of the alphabetic to each marker icon.
      for (let i = 0; i < results.length; i++) {
        const markerLetter = String.fromCharCode("A".charCodeAt(0) + (i % 26));
        const markerIcon = MARKER_PATH + markerLetter + ".png";

        // Use marker animation to drop the icons incrementally on the map.
        markers[i] = new google.maps.Marker({
          position: results[i].geometry.location,
          animation: google.maps.Animation.DROP,
          icon: markerIcon,
        });
        // If the user clicks a hotel marker, show the details of that hotel
        // in an info window.
        // @ts-ignore TODO refactor to avoid storing on marker
        markers[i].placeResult = results[i];
        google.maps.event.addListener(markers[i], "click", showInfoWindow);
        setTimeout(dropMarker(i), i * 100);
       // addResult(results[i], i);
      }
    }
  });
}

function clearMarkers() {
  for (let i = 0; i < markers.length; i++) {
    if (markers[i]) {
      markers[i].setMap(null);
    }
  }

  markers = [];
}

// Set the country restriction based on user input.
// Also center and zoom the map on the given country.
function setAutocompleteCountry() {
  const country = document.getElementById("country").value;

  if (country == "all") {
    autocomplete.setComponentRestrictions({ country: [] });
    map.setCenter({ lat: 15, lng: 0 });
    map.setZoom(2);
  } else {
    autocomplete.setComponentRestrictions({ country: country });
    map.setCenter(countries[country].center);
    map.setZoom(countries[country].zoom);
  }

  clearResults();
  clearMarkers();
}

function dropMarker(i) {
  return function () {
    markers[i].setMap(map);
  };
}
function addStore(sEl){
  const storesList = document.getElementById("storesList");
  storesList.appendChild(sEl);
}
function createStoreEl(s,i){
  const store = document.createElement("div");
  store.className="store-box";
  store.onclick = function () {
    google.maps.event.trigger(markers[i], "click");
  };
  const storeMain = document.createElement("div");
  storeMain.className="store-main";
  const storeImgDiv = document.createElement("div");
  storeImgDiv.className="store-img";
  if(s.store_image !=null && s.store_image !=""){
    const storeImg = document.createElement("img");
   // storeImg.src ="/cdn/shop/" + s.store_image;
   storeImg.src =s.store_image;
    storeImgDiv.appendChild(storeImg);
  }
  storeMain.appendChild(storeImgDiv);

  const storeInfo=document.createElement("div");
  storeInfo.className="store-info";
  if(s.name !=null && s.name !=""){
    const storeName = document.createElement("div");
    storeName.className="store-name";
    const name = document.createTextNode(s.name);
    storeName.appendChild(name);
    storeInfo.appendChild(storeName);
  }

  let addressText="";
  if((s.street !="" && s.street != null) || (s.city!="" && s.city != null) || (s.state!="" && s.state != null) || (s.postal_code !="" && s.postal_code != null) || (s.country!="" && s.country  != null)){
    const storeAddress = document.createElement("div");
    storeAddress.className="store-address";
    
    if(s.street !="" && s.street != null){
      addressText= s.street;
    }
    if(s.city!="" && s.city != null){
      if(addressText!=""){
        addressText += ",";
      }
      addressText += s.city;
    }
    if(s.state!="" && s.state != null){
      if(addressText!=""){
        addressText += ",";
      }
      addressText += s.state;
    }
    if(s.postal_code!="" && s.postal_code != null){
      if(addressText!=""){
        addressText += ",";
      }
      addressText += s.postal_code;
    }


    if(s.country!="" && s.country  != null){
      if(addressText!=""){
        addressText += ",";
      }
      addressText += s.country;
    }

    
    //const address = document.createTextNode(addressText);
    const address = document.createElement("a");
    // 设置href属性
    if(s.latitude && s.longitude){
      address.href="https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination="+ s.latitude + "," + s.longitude
    }else{
      address.href="https://maps.google.com/?daddr=" + addressText
    }
    // 设置链接文本
    address.innerText = addressText;
    storeAddress.appendChild(address);
    storeInfo.appendChild(storeAddress);
  }

  if(s.email != "" && s.email !=null){
    const svgEl=document.querySelector(".icon-email svg");
    // 克隆整个SVG节点（深克隆）
    const clonedSvg = svgEl.cloneNode(true);
    const storeEmail = document.createElement("div");
    storeEmail.className="store-email";
    storeEmail.appendChild(clonedSvg);

    const emailTag = document.createElement("span");
    emailTag.className="store-email-tag";
    const tag=document.createTextNode("Email:");
    emailTag.appendChild(tag);
    storeEmail.appendChild(emailTag);

    const emailTxt = document.createElement("a");
    emailTxt.href = "mailto:" + s.phone;
    const txt =document.createTextNode(s.email);
    emailTxt.appendChild(txt);
    storeEmail.appendChild(emailTxt);

    storeInfo.appendChild(storeEmail);
  }

  if(s.phone !="" && s.phone !=null){
    const svgEl=document.querySelector(".icon-phone svg");
    // 克隆整个SVG节点（深克隆）
    const clonedSvg = svgEl.cloneNode(true);
    const storePhone = document.createElement("div");
    storePhone.className="store-phone";
    storePhone.appendChild(clonedSvg);

    const phoneTag = document.createElement("span");
    phoneTag.className="store-phone-tag";
    const tag=document.createTextNode("Phone:");
    phoneTag.appendChild(tag);
    storePhone.appendChild(phoneTag);

    const phoneTxt = document.createElement("a");
    phoneTxt.href = "tel:" + s.phone;
    const txt =document.createTextNode(s.phone);
    phoneTxt.appendChild(txt);
    storePhone.appendChild(phoneTxt);

    storeInfo.appendChild(storePhone);
  }

  if(s.web_text!="" && s.web_text !=null){

    const svgEl=document.querySelector(".icon-website svg");
    // 克隆整个SVG节点（深克隆）
    const clonedSvg = svgEl.cloneNode(true);
    const storeWebsite = document.createElement("div");
    storeWebsite.className="store-webSite";
    storeWebsite.appendChild(clonedSvg);

    const websiteTag = document.createElement("span");
    websiteTag.className="store-webSite-tag";
    const tag=document.createTextNode("Website:");
    websiteTag.appendChild(tag);
    storeWebsite.appendChild(websiteTag);

    const websiteTxt = document.createElement("a");
    // 设置href属性
    websiteTxt.href = s.web_link;
    // 设置链接文本
    websiteTxt.innerText = s.web_text;
    //const txt =document.createTextNode(s.web_text);
  //  websiteTxt.appendChild(txt);
    storeWebsite.appendChild(websiteTxt);

    storeInfo.appendChild(storeWebsite);
  }
  

  storeMain.appendChild(storeInfo);
  store.appendChild(storeMain);

  const storeBtn = document.createElement("div");
  storeBtn.className="store-btn";
  const detailsBtn = document.createElement("div");
  detailsBtn.className="details-btn";
  const detailsBtnA = document.createElement("a");
  detailsBtnA.textContent = 'View Details';
  detailsBtnA.href="/pages/privacy-policy?view=store-locator-detail-page&store=" + s.handle
  detailsBtn.appendChild(detailsBtnA)
  storeBtn.appendChild(detailsBtn);
  const directionsBtn = document.createElement("div");
   directionsBtn.className="directions-btn";
  const directionsBtnA = document.createElement("a");
  if(s.latitude && s.longitude){
    directionsBtnA.href="https://www.google.com/maps/dir/?api=1&origin=Current+Location&destination="+ s.latitude + "," + s.longitude
  }else{
    directionsBtnA.href="https://maps.google.com/?daddr=" + addressText
  }
  directionsBtnA.textContent = 'GET DIRECTIONS';
  directionsBtn.appendChild(directionsBtnA)
  storeBtn.appendChild(directionsBtn)

  store.appendChild(storeBtn);
  return store;
}



function addResult(result, i) {
  const results = document.getElementById("results");
  const markerLetter = String.fromCharCode("A".charCodeAt(0) + (i % 26));
  const markerIcon = MARKER_PATH + markerLetter + ".png";
  const tr = document.createElement("tr");

  tr.style.backgroundColor = i % 2 === 0 ? "#F0F0F0" : "#FFFFFF";
  tr.onclick = function () {
    google.maps.event.trigger(markers[i], "click");
  };

  const iconTd = document.createElement("td");
  const nameTd = document.createElement("td");
  const icon = document.createElement("img");

  icon.src = markerIcon;
  icon.setAttribute("class", "placeIcon");
  icon.setAttribute("className", "placeIcon");

  const name = document.createTextNode(result.name);

  iconTd.appendChild(icon);
  nameTd.appendChild(name);
  tr.appendChild(iconTd);
  tr.appendChild(nameTd);
  results.appendChild(tr);
}
function clearStores() {
  const results = document.getElementById("storesList");

  while (results.childNodes[0]) {
    results.removeChild(results.childNodes[0]);
  }
}
function clearResults() {
  const results = document.getElementById("results");

  while (results.childNodes[0]) {
    results.removeChild(results.childNodes[0]);
  }
}

// Get the place details for a hotel. Show the information in an info window,
// anchored on the marker for the hotel that the user selected.
function showInfoWindow() {
  // @ts-ignore
  const marker = this;

  places.getDetails(
    { placeId: marker.placeResult.place_id },
    (place, status) => {
      if (status !== google.maps.places.PlacesServiceStatus.OK) {
        return;
      }

      infoWindow.open(map, marker);
      buildIWContent(place);
    },
  );
}

// Load the place information into the HTML elements used by the info window.
function buildIWContent(place) {
  document.getElementById("iw-icon").innerHTML =
    '<img class="hotelIcon" ' + 'src="' + place.icon + '"/>';
  document.getElementById("iw-url").innerHTML =
    '<b><a href="' + place.url + '">' + place.name + "</a></b>";
  document.getElementById("iw-address").textContent = place.vicinity;
  if (place.formatted_phone_number) {
    document.getElementById("iw-phone-row").style.display = "";
    document.getElementById("iw-phone").textContent =
      place.formatted_phone_number;
  } else {
    document.getElementById("iw-phone-row").style.display = "none";
  }

  // Assign a five-star rating to the hotel, using a black star ('&#10029;')
  // to indicate the rating the hotel has earned, and a white star ('&#10025;')
  // for the rating points not achieved.
  if (place.rating) {
    let ratingHtml = "";

    for (let i = 0; i < 5; i++) {
      if (place.rating < i + 0.5) {
        ratingHtml += "&#10025;";
      } else {
        ratingHtml += "&#10029;";
      }

      document.getElementById("iw-rating-row").style.display = "";
      document.getElementById("iw-rating").innerHTML = ratingHtml;
    }
  } else {
    document.getElementById("iw-rating-row").style.display = "none";
  }

  // The regexp isolates the first part of the URL (domain plus subdomain)
  // to give a short URL for displaying in the info window.
  if (place.website) {
    let fullUrl = place.website;
    let website = String(hostnameRegexp.exec(place.website));

    if (!website) {
      website = "http://" + place.website + "/";
      fullUrl = website;
    }

    document.getElementById("iw-website-row").style.display = "";
    document.getElementById("iw-website").textContent = website;
  } else {
    document.getElementById("iw-website-row").style.display = "none";
  }
}

window.initMap = initMap;
